<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.dc_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "单据日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.createTime
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="had_emname">
            <label class="weui-form-preview__label">{{customLabel.had_emname || "姓名"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.had_emname }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="had_deptname">
            <label class="weui-form-preview__label">{{customLabel.had_deptname || "部门"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.had_deptname }}
            </span>
          </div>
        </custom-layout>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="dc_actual_time_old">
            <label class="weui-form-preview__label">{{customLabel.dc_actual_time_old || "原实际工作时长"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.dc_actual_time_old
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="dc_actual_time_new">
            <label class="weui-form-preview__label">{{customLabel.dc_actual_time_new || "新实际工作时长"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.dc_actual_time_new }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_ot_time_old">
            <label class="weui-form-preview__label">{{customLabel.dc_ot_time_old || "原加班时长"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_ot_time_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_ot_time_new">
            <label class="weui-form-preview__label">{{customLabel.dc_ot_time_new || "新加班时长"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_ot_time_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_ot_exchange_old">
            <label class="weui-form-preview__label">{{customLabel.dc_ot_exchange_old || "原工作日加班（调休）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_ot_exchange_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_ot_exchange_new">
            <label class="weui-form-preview__label">{{customLabel.dc_ot_exchange_new || "新工作日加班（调休）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_ot_exchange_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_ot_pay_old">
            <label class="weui-form-preview__label">{{customLabel.dc_ot_pay_old || "原工作日（加班费）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_ot_pay_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_ot_pay_new">
            <label class="weui-form-preview__label">{{customLabel.dc_ot_pay_new || "新工作日（加班费）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_ot_pay_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_rest_ot_exchange_old">
            <label class="weui-form-preview__label">{{customLabel.dc_rest_ot_exchange_old || "原休息日加班（调休）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_rest_ot_exchange_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_rest_ot_exchange_new">
            <label class="weui-form-preview__label">{{customLabel.dc_rest_ot_exchange_new || "新休息日加班（调休）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_rest_ot_exchange_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_rest_ot_pay_old">
            <label class="weui-form-preview__label">{{customLabel.dc_rest_ot_pay_old || "原休息日（加班费）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_rest_ot_pay_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_rest_ot_pay_new">
            <label class="weui-form-preview__label">{{customLabel.dc_rest_ot_pay_new || "新休息日加班（调休）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_rest_ot_pay_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_holiday_ot_exchange_old">
            <label class="weui-form-preview__label">{{customLabel.dc_holiday_ot_exchange_old || "原节假日加班（调休）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_holiday_ot_exchange_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_holiday_ot_exchange_new">
            <label class="weui-form-preview__label">{{customLabel.dc_holiday_ot_exchange_new || "新节假日加班（调休）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_holiday_ot_exchange_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_holiday_ot_pay_old">
            <label class="weui-form-preview__label">{{customLabel.dc_holiday_ot_pay_old || "原节假日（加班费）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_holiday_ot_pay_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_holiday_ot_pay_new">
            <label class="weui-form-preview__label">{{customLabel.dc_holiday_ot_pay_new || "新节假日（加班费）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_holiday_ot_pay_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_late_time_old">
            <label class="weui-form-preview__label">{{customLabel.dc_late_time_old || "原迟到（分钟）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_late_time_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_late_time_new">
            <label class="weui-form-preview__label">{{customLabel.dc_late_time_new || "新迟到（分钟）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_late_time_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_late_count_old">
            <label class="weui-form-preview__label">{{customLabel.dc_late_count_old || "原迟到（次数）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_late_count_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_late_count_new">
            <label class="weui-form-preview__label">{{customLabel.dc_late_count_new || "新迟到（次数）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_late_count_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_leave_early_time_old">
            <label class="weui-form-preview__label">{{customLabel.dc_leave_early_time_old || "原早退（分钟）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_leave_early_time_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_leave_early_time_new">
            <label class="weui-form-preview__label">{{customLabel.dc_leave_early_time_new || "新早退（分钟）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_leave_early_time_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_leave_early_count_old">
            <label class="weui-form-preview__label">{{customLabel.dc_leave_early_count_old || "原早退（次数）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_leave_early_count_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_leave_early_count_new">
            <label class="weui-form-preview__label">{{customLabel.dc_leave_early_count_new || "新早退（次数）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_leave_early_count_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_absenteeism_time_old">
            <label class="weui-form-preview__label">{{customLabel.dc_absenteeism_time_old || "原旷工（天）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_absenteeism_time_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_absenteeism_time_new">
            <label class="weui-form-preview__label">{{customLabel.dc_absenteeism_time_new || "新旷工（天）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_absenteeism_time_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_absenteeism_count_old">
            <label class="weui-form-preview__label">{{customLabel.dc_absenteeism_count_old || "原旷工（次数）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_absenteeism_count_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_absenteeism_count_new">
            <label class="weui-form-preview__label">{{customLabel.dc_absenteeism_count_new || "新旷工（次数）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_absenteeism_count_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_annual_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_annual_hour_old || "原年假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_annual_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_annual_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_annual_hour_new || "新年假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_annual_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_marry_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_marry_hour_old || "原事假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_marry_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_marry_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_marry_hour_new || "新年假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_marry_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_sick_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_sick_hour_old || "原病假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_sick_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_sick_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_sick_hour_new || "新病假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_sick_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_exchange_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_exchange_hour_old || "原调休假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_exchange_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_exchange_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_exchange_hour_new || "新调休假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_exchange_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_marry_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_marry_hour_old || "原婚假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_marry_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_marry_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_marry_hour_new || "新婚假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_marry_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_maternity_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_maternity_hour_old || "原产假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_maternity_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_maternity_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_maternity_hour_new || "新产假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_maternity_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_paternity_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_paternity_hour_old || "原陪产假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_paternity_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_paternity_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_paternity_hour_new || "新陪产假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_paternity_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_other_day_old">
            <label class="weui-form-preview__label">{{customLabel.dc_other_day_old || "原其他（天）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_other_day_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_other_day_new">
            <label class="weui-form-preview__label">{{customLabel.dc_other_day_new || "新其他（天）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_other_day_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_funeral_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_funeral_hour_old || "原丧假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_funeral_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_funeral_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_funeral_hour_new || "新丧假（小时）"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_funeral_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_newyear_hour_old">
            <label class="weui-form-preview__label">{{customLabel.dc_newyear_hour_old || "原春节必休"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_newyear_hour_old }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_newyear_hour_new">
            <label class="weui-form-preview__label">{{customLabel.dc_newyear_hour_new || "新春节必休"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_newyear_hour_new }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="updaterName">
            <label class="weui-form-preview__label">{{customLabel.updaterName || "变更人"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.updaterName }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_auditman">
            <label class="weui-form-preview__label">{{customLabel.dc_auditman || "审核人"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_auditman }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="dc_reason">
            <label class="weui-form-preview__label">{{customLabel.dc_reason || "变更原因"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.dc_reason }}
            </span>
          </div>
        </custom-layout>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/hr/day/change"
    }
  }
}
</script>